var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 6.91669C13.9503 6.91669 7.41699 13.45 7.41699 21.5C7.41699 29.55 13.9503 36.0834 22.0003 36.0834C30.0503 36.0834 36.5837 29.55 36.5837 21.5C36.5837 13.45 30.0503 6.91669 22.0003 6.91669ZM10.3337 21.5C10.3337 20.6104 10.4503 19.7354 10.6399 18.9042L17.6107 25.875V27.3334C17.6107 28.9375 18.9232 30.25 20.5274 30.25V33.0646C14.7962 32.3354 10.3337 27.4354 10.3337 21.5ZM30.5899 29.375C30.2107 28.1938 29.1316 27.3334 27.8191 27.3334H26.3607V22.9584C26.3607 22.1563 25.7045 21.5 24.9024 21.5H16.1524V18.5834H19.0691C19.8712 18.5834 20.5274 17.9271 20.5274 17.125V14.2084H23.4441C25.0482 14.2084 26.3607 12.8959 26.3607 11.2917V10.6938C30.6337 12.4146 33.667 16.6146 33.667 21.5C33.667 24.5334 32.4857 27.3042 30.5899 29.375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.b9713c47012ea9f68a189859bd73f497.svg";
export { ForwardRef as ReactComponent };